module.exports = __webpack_public_path__ + "static/dc1000-4b8ec766d1a0b92510f4a1459bfcaacb.png";